import { FileText } from 'lucide-vue-next';
import TextEditorPanel from '@/components/panels/TextEditorPanel.vue';
import { disposeModel } from '@/composables/editor-models.js';
import type { PanelOpener } from '@/composables/use-panels.js';
import { createFileIconComponent } from '@/lib/file-icons.js';

export type FileOpenerDeps = {
	closeFile: (path: string) => void;
};

export const createFileOpener = (deps: FileOpenerDeps): PanelOpener => ({
	scheme: 'file',
	defaultRegion: 'center',
	allowedRegions: ['center', 'bottom'],
	resolve(uri) {
		const path = uri.slice('file://'.length);
		const name = path.split('/').pop() ?? path;
		return {
			uri,
			title: name,
			icon: createFileIconComponent(name) ?? FileText,
			component: TextEditorPanel,
			props: { path },
			closable: true,
			onClose() {
				deps.closeFile(path);
				disposeModel(path);
			},
		};
	},
});
